import { IModel, Model } from "@common/models/Model";
import { SyncableDictionary } from "@common/types/SyncableDictionary";
export interface ISyncModel extends IModel {
    __modelSyncId?: string | undefined;
    syncableProps?: SyncableDictionary | undefined;
}

export class SyncModel extends Model implements ISyncModel {
    __modelSyncId: string | undefined
    syncableProps: SyncableDictionary | undefined;

    constructor(params?: Partial<ISyncModel>) {
        super(params);
        this.__modelSyncId = _.defaultTo(params?.__modelSyncId, '');
        this.syncableProps = _.defaultTo(params?.syncableProps, undefined);
    }

}
